import http from "../axios";

const questionDataApi ={
    // 根据前置条件筛选出后置条件列表 区域
    getLocaleOptions(data){
        return http({
            url: "/ExercisePool/LocaleOptions",
            method: "POST",
            data: data,
          });
    },
    // 获取表格数据
    getLocaleUseList(data){
        return http({
            url: "/ExercisePool/LocaleUse",
            method: "POST",
            data: data,
          });
    },
    // 根据题库ID获取学校列表
    getSchoolListByExercisePoolID(data){
        return http({
            url: "/ExercisePool/getSchoolListByExercisePoolID",
            method: "GET",
            params: data,
          });
    },
    // 获取表格数据 题库使用分析_区域明细
    getLocaleUseDetailsList(data){
        return http({
            url: "/ExercisePool/LocaleUseDetails",
            method: "POST",
            data: data,
          });
    },
    // 根据前置条件筛选出后置条件列表 学校
    getSchoolOptions(data){
        return http({
            url: "/ExercisePool/SchoolOptions",
            method: "POST",
            data: data,
          });
    },
    // 获取表格数据
    getSchoolUseList(data){
        return http({
            url: "/ExercisePool/SchoolUse",
            method: "POST",
            data: data,
          });
    },
    // 获取区域题库列表
    getLocaleExercisePoolListFuzzyQuery(data){
        return http({
            url: "/ExercisePool/LocaleExercisePoolListFuzzyQuery",
            method: "POST",
            data: data,
          });
    },
    // 获取学校题库列表
    getSchoolExercisePoolListFuzzyQuery(data){
        return http({
            url: "/ExercisePool/SchoolExercisePoolListFuzzyQuery",
            method: "POST",
            data: data,
          });
    },
    // 获取学校
    getSchoolListFuzzyQuery(data){
        return http({
            url: "/ExercisePool/SchoolListFuzzyQuery",
            method: "POST",
            data: data,
          });
    },
}

export default questionDataApi